export default __webpack_public_path__ + "static/media/Senegal.38437a14.png";